/* AB1ファイルのファイルシグネチャ ('ABIF' ASCII = 0x41 0x42 0x49 0x46) */
const ABIF_SIGNATURE_BYTES = [0x41, 0x42, 0x49, 0x46];

/**
 * AB1ファイルのバリデーション
 * 
 * ファイルの拡張子とシグネチャを確認します。
 * 詳細なバリデーションはサーバーに委ねます。
 * 
 * @param {File} file AB1ファイルオブジェクト
 * @returns {Promise<{isValid: boolean, msg: string}>} AB1ファイルのバリデーションの結果とメッセージを解決するPromise
 */
export const validateAb1File = (file) => {
    return new Promise((resolve) => {
        if (!file) {
            resolve({ isValid: false, msg: 'No file set.' });
            return;
        }
        if (!file.name.toLowerCase().endsWith('.ab1')) {
            resolve({ isValid: false, msg: 'Invalid file format. Please set a valid AB1 file.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (event) => {
            const arrayBuffer = event.target.result;
            const uint8Array = new Uint8Array(arrayBuffer);

            if (!uint8Array || uint8Array.length < ABIF_SIGNATURE_BYTES.length) {
                resolve({ isValid: false, msg: 'File is too short for AB1 signature check.' });
                return;
            }
            for (let i = 0; i < ABIF_SIGNATURE_BYTES.length; i++) {
                if (uint8Array[i] !== ABIF_SIGNATURE_BYTES[i]) {
                    resolve({ isValid: false, msg: 'Invalid AB1 file signature. Expected "ABIF".' });
                    return;
                }
            }
            // 全ての同期・非同期バリデーションを通過した場合
            resolve({ isValid: true, msg: 'File format and signature are valid.' });
        };

        reader.onerror = () => {
            // エラーが発生した場合
            resolve({ isValid: false, msg: 'Failed to read file.' });
        };

        // ファイルを ArrayBuffer として読み込む。これが非同期処理の開始点。
        reader.readAsArrayBuffer(file);
    });
};

/**
 * Base64にエンコードする非同期メソッド
 * 
 * @param {File} file エンコード対象のファイル
 * @returns {Promise<string>} ファイルをBASE64エンコードした文字列のPromise
 */
export const getBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]); // split でヘッダ部分を削除
    reader.onerror = error => reject(error);
    reader.readAsDataURL(file);
});
